import api from "./index";

export async function getJurisdictions(params) {
  return api.get(`/comarcas`, { params });
}
